/* Progressive enhancement: the complete server-rendered archive remains usable without JS. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.hubReady) return;
    const isAz = /^az(?:-|$)/i.test(document.documentElement.lang || '');
    const isFr = /^fr(?:-|$)/i.test(document.documentElement.lang || '');
    const grid = root.querySelector('[data-hub-grid]');
    const input = root.querySelector('[data-hub-search]');
    if (!grid || !input) return;
    const spotlight = root.querySelector('[data-hub-spotlight]');
    const more = root.querySelector('[data-hub-more]');
    const status = root.querySelector('[data-hub-status]');
    const empty = root.querySelector('[data-hub-empty]');
    const heading = root.querySelector('[data-hub-feed-title]');
    const pages = root.querySelector('[data-hub-pages]');
    const filters = [...root.querySelectorAll('[data-hub-filter]')];
    const cards = [...root.querySelectorAll('[data-hub-article]')];
    const ids = new Set(cards.map(card => card.dataset.articleId));
    const slots = [...root.querySelectorAll('[data-hub-slot]')].map(slot => ({
      slot, card: slot.querySelector('[data-hub-article]'),
      mode: slot.querySelector('[data-hub-article]')?.className
    })).filter(item => item.card);
    const featured = new Set(slots.map(item => item.card));
    let next = root.querySelector('[data-hub-next]')?.getAttribute('href') || '';
    let topic = 'all', query = '', limit = 6, archiveError = false, pending = null;
    let matched = [], searchTimer;
    const normalise = value => value.normalize('NFKC').toLocaleLowerCase().trim();
    const topicsOf = card => (card.dataset.topics || 'all').split(/\s+/);
    const updateCounts = () => {
      const counts = Object.create(null);
      cards.forEach(card => new Set(topicsOf(card)).forEach(key => { counts[key] = (counts[key] || 0) + 1; }));
      root.querySelectorAll('[data-count]').forEach(label => {
        label.textContent = `(${counts[label.dataset.count] || 0}${next ? '+' : ''})`;
      });
      filters.forEach(button => { button.hidden = button.dataset.hubFilter !== 'all' && !counts[button.dataset.hubFilter] && !next; });
    };
    function render() {
      const filtering = Boolean(query || topic !== 'all');
      if (spotlight) spotlight.hidden = filtering;
      slots.forEach(({slot,card,mode}) => {
        if (filtering) {
          card.classList.remove('en-hub-card--lead','en-hub-card--secondary');
          if (card.parentElement !== grid) grid.appendChild(card);
        } else {
          card.className = mode;
          slot.appendChild(card);
          card.hidden = false;
        }
      });
      const words = normalise(query).split(/\s+/).filter(Boolean);
      matched = cards.filter(card => {
        if (!filtering && featured.has(card)) return false;
        const text = normalise(card.dataset.search || '');
        return (topic === 'all' || topicsOf(card).includes(topic)) && words.every(word => text.includes(word));
      });
      const visible = new Set(matched.slice(0,limit));
      cards.forEach(card => {
        if (!filtering && featured.has(card)) return;
        card.hidden = !visible.has(card);
        // DOM order remains chronological even after moving featured cards into search results.
        grid.appendChild(card);
      });
      filters.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.hubFilter === topic)));
      heading.textContent = filtering ? (isAz ? 'Məqalə nəticələri' : 'Article results') : (isAz ? 'Son məqalələr' : 'Latest articles');
      empty.hidden = matched.length > 0 || Boolean(pending);
      more.hidden = matched.length <= limit && !next;
      more.disabled = Boolean(pending);
      status.textContent = pending ? (isAz ? 'Məqalə arxivində axtarış aparılır…' : 'Searching the article archive…') : archiveError
        ? (isAz ? 'Arxivin bəzi səhifələri yüklənmədi. Nəticələr yüklənmiş məqalələri əhatə edir; davam etmək üçün səhifə keçidlərindən istifadə edin.' : 'Some archive pages could not load. Results below cover the loaded articles; use the page links to continue.')
        : isAz ? `Göstərilən: ${Math.min(limit,matched.length)} / ${matched.length}${next ? '+' : ''} məqalə` : `Showing ${Math.min(limit,matched.length)} of ${matched.length}${next ? '+' : ''} ${filtering ? 'matching' : 'latest'} articles`;
      if (isFr) {
        heading.textContent = filtering ? 'Résultats des articles' : 'Derniers articles';
        status.textContent = pending ? 'Recherche dans les archives des articles…' : archiveError
          ? 'Certaines pages des archives n’ont pas pu être chargées. Consultez les résultats déjà disponibles ou utilisez la pagination.'
          : `Affichage de ${Math.min(limit,matched.length)} sur ${matched.length}${next ? '+' : ''} articles ${filtering ? 'correspondants' : 'récents'}`;
      }
      if (pages) pages.hidden = !archiveError;
      updateCounts();
    }
    async function fetchNext() {
      if (!next) return;
      const url = new URL(next,location.href);
      if (url.origin !== location.origin || !url.pathname.startsWith(root.dataset.blogUrl)) throw new Error('Unexpected archive destination');
      url.searchParams.set('section_id',root.dataset.sectionId);
      const response = await fetch(url.toString(),{credentials:'same-origin',headers:{'Accept':'text/html'}});
      if (!response.ok) throw new Error(`Archive response ${response.status}`);
      const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
      const remote = parsed.querySelector('[data-news-hub]');
      if (!remote) throw new Error('Missing archive section');
      remote.querySelectorAll('[data-hub-article]').forEach(card => {
        if (ids.has(card.dataset.articleId)) return;
        ids.add(card.dataset.articleId);
        const imported = document.importNode(card,true);
        imported.classList.remove('en-hub-card--lead','en-hub-card--secondary');
        cards.push(imported); grid.appendChild(imported);
      });
      const following = remote.querySelector('[data-hub-next]')?.getAttribute('href') || '';
      if (following === next) throw new Error('Repeated archive cursor');
      next = following;
    }
    async function ensureArchive(all = false) {
      if (!next) return;
      if (pending) { await pending; if (all && next && !archiveError) await ensureArchive(true); return; }
      archiveError = false;
      pending = (async () => { do { await fetchNext(); } while (all && next); })();
      render();
      try { await pending; } catch (error) { archiveError = true; console.warn('Euronavigate article archive:',error.message); }
      finally { pending = null; render(); }
    }
    filters.forEach(button => button.addEventListener('click',() => {
      const preserveScroll = Boolean(button.closest('.en-hub-sidebar'));
      const preservedY = preserveScroll ? window.scrollY : 0;
      const restoreScroll = () => {
        if (preserveScroll) window.scrollTo({top:preservedY,left:window.scrollX,behavior:'auto'});
      };
      topic = button.dataset.hubFilter; limit = 6; render();
      const archiveLoad = topic !== 'all' ? ensureArchive(true) : Promise.resolve();
      restoreScroll();
      if (preserveScroll) {
        requestAnimationFrame(restoreScroll);
        void archiveLoad.finally(() => {
          restoreScroll();
          requestAnimationFrame(restoreScroll);
        });
      }
    }));
    input.addEventListener('input',() => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => { query = input.value; limit = 6; render(); if (query) void ensureArchive(true); },150);
    });
    root.querySelector('[data-hub-reset]').addEventListener('click',() => {
      clearTimeout(searchTimer); input.value=''; query=''; topic='all'; limit=6; render(); input.focus();
    });
    more.addEventListener('click',async () => {
      const previous = new Set(matched.slice(0,limit));
      limit += 6;
      if (matched.length < limit && next) await ensureArchive(false);
      render();
      const firstAdded = matched.slice(0,limit).find(card => !previous.has(card));
      firstAdded?.querySelector('h3 a')?.focus({preventScroll:true});
    });
    root.dataset.hubReady='true';
    root.querySelectorAll('[data-hub-controls]').forEach(control => { control.hidden=false; });
    render();
  }
  function scan(context=document) { context.querySelectorAll('[data-news-hub]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();
